import { Box } from "@mui/material";
import { ReactComponent as ActionCompleted } from "assets/ActionCompleted.svg";
import { ReactComponent as PlanCompleted } from "assets/PlanCompleted.svg";
import { setCardsCompletedPrev } from "components/app/App.slice";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { tokens } from "styles/Tokens";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

function RecognitionsDialog() {
  const dispatch = useAppDispatch();
  const cardsCompletedPrev: any = useAppSelector((state) => state.app.cardsCompletedPrev);
  const myPlanDetails: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const { cardsCompleted, totalCards } = myPlanDetails;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isEmpty(myPlanDetails) && totalCards > 0) {
      if ((cardsCompletedPrev === 0 || cardsCompletedPrev === -1) && cardsCompleted === 1) {
        setOpen(true);
      }
      if (cardsCompleted === totalCards && cardsCompleted !== cardsCompletedPrev) {
        setOpen(true);
      }
    }
  }, [cardsCompletedPrev, cardsCompleted, totalCards, myPlanDetails]);

  const closeHandler = () => {
    dispatch(setCardsCompletedPrev(myPlanDetails.cardsCompleted));
    setOpen(false);
  };

  return (
    <DialogFormation openDialog={open} handleClose={closeHandler}>
      <div className="horizontal-center text-center">
        <div>
          <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
            <Box sx={{ marginBottom: "5px" }}>Great Job!</Box>
            {totalCards === cardsCompleted
              ? `You have fully completed Plan ${myPlanDetails.name}! `
              : "You completed the action."}
          </Typography>
          <Box sx={{ padding: "10px" }}>{totalCards === cardsCompleted ? <PlanCompleted /> : <ActionCompleted />}</Box>
          <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
            Keep up the good work.
          </Typography>
        </div>
      </div>
    </DialogFormation>
  );
}

export default RecognitionsDialog;
